var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobAds(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6796 13.6145L22.2853 9.99732C22.5036 9.86489 22.6896 9.68536 22.8297 9.47184C22.9698 9.25831 23.0604 9.01619 23.0949 8.76317C23.1294 8.51015 23.1069 8.25261 23.0291 8.00938C22.9514 7.76615 22.8202 7.54337 22.6453 7.35732L17.1424 1.85446C16.9564 1.67955 16.7336 1.5484 16.4904 1.47062C16.2471 1.39284 15.9896 1.37038 15.7366 1.40488C15.4836 1.43938 15.2414 1.52998 15.0279 1.67005C14.8144 1.81011 14.6349 1.99612 14.5024 2.21446L10.7996 7.75161L3.10243 9.46589C2.92642 9.5086 2.7648 9.59704 2.63392 9.72225C2.50305 9.84746 2.40756 10.005 2.35711 10.179C2.30666 10.3529 2.30304 10.5371 2.34662 10.7129C2.3902 10.8887 2.47943 11.0499 2.60529 11.1802L13.1481 21.7402C13.2816 21.8609 13.444 21.9452 13.6195 21.9849C13.7951 22.0245 13.9779 22.0182 14.1503 21.9664C14.3227 21.9147 14.4788 21.8194 14.6036 21.6897C14.7283 21.5599 14.8175 21.4002 14.8624 21.2259L16.6796 13.6145Z",
    stroke: "white",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86836 16.5801L0.856934 23.6429",
    stroke: "white",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobAds);
export default __webpack_public_path__ + "static/media/jobAds.de485a775f9c6b607b7b10a1ea157ac8.svg";
export { ForwardRef as ReactComponent };